<template>
   <div class="talRecordSetup">
        <div class="scroll-box">
            <div class="tr-li">
                <div class="lable-txt"></div>
                <div class="from-input">
                    <el-checkbox v-model="isEnableTalRecord" label="启用来电显示功能"></el-checkbox>
                </div>
            </div>
            <div class="tr-li">
                <div class="lable-txt">硬件型号:</div>
                <div class="from-input">
                    <el-select v-model="brand" placeholder="请选择" >
                        <el-option label="记得-JD来电显示器" :value="1" > </el-option>
                    </el-select>
                </div>
            </div>
            <div class="tr-li">
                <div class="lable-txt">连接方式:</div>
                <div class="from-input">
                    <el-radio-group v-model="type">
                        <el-radio :label="1">USB连接</el-radio>
                        <el-radio :label="2">蓝牙连接</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="tr-li" v-if="type==2">
                <div class="lable-txt">蓝牙名称:</div>
                <div class="from-input">
                    <input type="text" v-model="name"/>
                </div>
            </div>
            <p class="explain">注：连接方式只针对安卓设备</p>
        </div>
        <div class="footer-box">
            <button class="btn" @click="back();">返回</button>
            <button class="btn selected" @click="saveConfig()">保存配置</button>
        </div>
   </div>
</template>

<script>
export default {
    name:'talRecordSetup',
    data(){
        return {
            /**硬件型号*/
            brand:1,//1 (记得-JD来电显示器)
            type:1,//1:USB连接 2:蓝牙连接
            isEnableTalRecord:false,
            name:"JD2000S"
        }
    },
    mounted(){
        
        this.$webBrowser.getTalRecordConfig().then(d=>{//获取电显示
            if(d){
                this.isEnableTalRecord=d.isEnableTalRecord==true;
                this.brand=d.brand||this.brand;
                this.type=d.type||1;
                if(d.name){
                    this.name=d.name;
                }
               
            }
        });
    },
    methods:{
        /**退出 */
        back(){
            this.$emit("close");
        },
        /**保存配置 */
        saveConfig(){
            let data={
                brand:this.brand,
                type:this.type,
                isEnableTalRecord:this.isEnableTalRecord,
                name:""
            }
            if(this.type==2){
                data.name=this.name;
            }
            this.$webBrowser.saveTalRecordConfig(data).then(d=>{
                if(d && d.state==0){
                    if(data.isEnableTalRecord){
                        this.callMonitorOpen(data);
                    }else{
                        this.callMonitorClose();
                    }
                    this.$message.success("保存成功");
                }
            });
        },
        //开启
        callMonitorOpen(data){
            if(!this.$global.isJDTelMonitor){
                this.$webBrowser.callMonitorOpen(data.type,data.name).then(d=>{
                    if(d && (d.status==0 || d.state==0)){
                        this.$global.isJDTelMonitor=true;
                        console.log("电话监听开启");
                    }else{
                        //this.$message.error("来电设备连接失败:"+(d?.message||""));
                    }
                })
            }
        },
        //关闭
        callMonitorClose(){
            if(this.$global.isJDTelMonitor){
                this.$webBrowser.callMonitorClose().then(d=>{
                    if(d && (d.status==0 || d.state==0)){
                        this.$global.isJDTelMonitor=false;
                        console.log("电话监听关闭");
                    }else{
                        //this.$message.error("来电设备连接失败:"+(d?.message||""));
                    }
                })
            }
        }
        
    }
}
</script>

<style lang="scss">
@import './talRecordSetup.scss';
</style>